// extracted by mini-css-extract-plugin
export var completionBody = "_lz-2";
export var completionCard = "_lz-0";
export var completionFooter = "_lz-3";
export var completionTitle = "_lz-1";